import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { BulletinBoardNoticeDetailsResponse } from 'src/apis/secondary-market-service/types';
import type { SecondaryMarketServiceRequest } from 'src/apis/secondary-market-service/use-secondary-market-service';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  secondaryMarketService: SecondaryMarketServiceRequest;
  bulletinBoardNoticeId: string;
};

type ExecuteProps = {
  url: string;
};

export function useBulletinBoardNotice({
  secondaryMarketService,
  bulletinBoardNoticeId,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<BulletinBoardNoticeDetailsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      !secondaryMarketService.response ||
      !secondaryMarketService.response.data._links.bulletinBoardNoticeDetails
        ?.href
    )
      return;

    const url = urlTemplate
      .parse(
        secondaryMarketService.response.data._links.bulletinBoardNoticeDetails
          .href
      )
      .expand({ noticeId: bulletinBoardNoticeId });

    request.execute({
      url,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [secondaryMarketService.response, bulletinBoardNoticeId]);

  return request;
}

export type BulletinBoardNoticeRequest = ReturnType<
  typeof useBulletinBoardNotice
>;
